import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { mainPinIdsFromForum, orderDiscussionsByConfiguredIds } from '../utils/mainLandingPins';

/**
 * Curated MAIN pin rows. Uses normal DiscussionListItem language — not a
 * separate promotional card system. Never grants visibility; server filters
 * already narrowed to actor-visible discussions.
 */
export default class MainLandingPins extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.discussions = [];
    this.load();
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "FlatRateMainLandingPins FlatRateMainLandingPins--loading",
        "aria-busy": "true"
      }, m(LoadingIndicator, null));
    }
    if (!this.discussions.length) {
      return null;
    }
    const params = app.search?.state && typeof app.search.state.params === 'function' && app.search.state.params() || {};
    return m("div", {
      className: "FlatRateMainLandingPins",
      "data-audience": this.attrs.audience
    }, m("ul", {
      className: "DiscussionList FlatRateMainLandingPins-list"
    }, this.discussions.map(discussion => m("li", {
      key: discussion.id(),
      "data-id": discussion.id(),
      className: "DiscussionList-item FlatRateMainLandingPins-item"
    }, m(DiscussionListItem, {
      discussion: discussion,
      params: params
    })))));
  }
  load() {
    const audience = this.attrs.audience === 'public' ? 'public' : 'member';
    const configuredIds = mainPinIdsFromForum(app.forum, audience);
    if (!configuredIds.length) {
      this.loading = false;
      this.discussions = [];
      return;
    }
    app.store.find('discussions', {
      filter: {
        flatrateMainPins: audience
      },
      include: 'user,lastPostedUser',
      page: {
        limit: Math.max(configuredIds.length, 1)
      }
    }).then(models => {
      const list = Array.isArray(models) ? models : models ? [models] : [];
      this.discussions = orderDiscussionsByConfiguredIds(list, configuredIds);
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.discussions = [];
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('flatrate-forum-navigation', 'forum/components/MainLandingPins', MainLandingPins);